module.exports = __webpack_public_path__ + "static/img/8.44c4f8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/8.png
// module id = ReBT
// module chunks = 0